import React, { Component } from 'react'
import { Action } from 'hljd'
import Store from './store'
import { observer } from 'mobx-react'
import OrderDetail from './OrderDetail'
import FlowDetail from './FlowDetail'

const Item = Action.Item

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  render() {
    const { tab, changeTab } = this.store
    return (
      <div style={{ backgroundColor: '#fff', marginTop: 20 }}>
        <Action active={tab} onChange={changeTab} style={{ paddingLeft: 20 }}>
          <Item value="1">合作订单明细</Item>
          <Item value="2">流水明细</Item>
        </Action>

        <div style={{ padding: 20 }}>
          {tab == 1 && <OrderDetail />}
          {tab == 2 && <FlowDetail />}
        </div>
      </div>
    )
  }
}
